import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { pagesText } from '../../../../constants/english'
import parse from "html-react-parser";
import { clearAll, showEvaluationDetailsFunc } from '../../../../config/redux/slice/notapUserSlice'
import { convertDateTime, getLetterHistoryUserName } from '../../../../utils/lib';

export default function EvaluationDetails() {
    const dispatch = useDispatch()
    const {
        certificateManagement:{certificateDetails},
        evaluationManagement: {evaluationDetails}
    } = useSelector((state) => state.notapUser)

    const closeModal = () => {
        dispatch(clearAll({}))
        dispatch(showEvaluationDetailsFunc({ modal: false }));
    };

  return (
    <div 
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >
  <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div className="modal-content">
     
        <div className="modal-header px-4">
          <h5 className="modal-title" id="exampleModalCenterTitle">Evaluation Summary</h5>
          <button 
            type="button" 
            className="close" 
            data-dismiss="modal" 
            aria-label="Close"
            onClick={()=>{closeModal()}}
        >
          <span aria-hidden="true">×</span>
        </button>
        </div>
        <div className="modal-body px-4 px-md-7">

            <table className="table table-borderless table-thead-border table-striped">
                          <thead>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Role</td>
                              <td className="py-2 px-2 text-dark">{evaluationDetails?.USER_ROLE_TEXT}</td>
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">User</td>
                              <td className="py-2 px-2 text-dark">{getLetterHistoryUserName(evaluationDetails)}</td>
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Comment</td>
                              {(evaluationDetails?.COMMENTS && evaluationDetails?.COMMENTS != '<p><br></p>' && evaluationDetails?.COMMENTS != '') ?
                              <td className="py-2 px-2 text-dark">{parse(evaluationDetails?.COMMENTS)}</td> :
                              <td className="py-2 px-2 text-dark">N/A</td>
                              }
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Letter</td>
                              {(evaluationDetails?.LETTER && evaluationDetails?.LETTER != '<p><br></p>' && evaluationDetails?.LETTER != '') ?
                              <td className="py-2 px-2 text-dark">{parse(evaluationDetails?.LETTER)}</td> :
                              <td className="py-2 px-2 text-dark">N/A</td>
                              }
                            </tr>
                            <tr>
                              <td className="py-2 px-2 text-dark font-weight-bold">Created At</td>
                              <td className="py-2 px-2 text-dark">
                                { evaluationDetails?.CREATED_AT ?
                                    convertDateTime(evaluationDetails?.CREATED_AT, pagesText.full_date) :
                                    ''
                                }    
                                    </td>           
                            </tr>
                          </tbody>
                        </table>

        </div>
        {/* <div className="modal-footer px-4 d-flex align-items-center">

        </div> */}

    </div>
  </div>
</div>
  )
}
